import React, { useState, useRef, useEffect } from "react";
import "../assets/styles/Home.scss";
import FadeIn from "./compliance/FadeIn";
import { NavLink } from "react-router-dom";
import { Box, Card, CardContent, Grid } from "@mui/material";

// Import icons
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import NetworkCheckIcon from "@mui/icons-material/NetworkCheck";
import ShopTwoIcon from "@mui/icons-material/ShopTwo";
import TranscribeIcon from "@mui/icons-material/Transcribe";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import MicIcon from "@mui/icons-material/Mic";
// import AssessmentIcon from "@mui/icons-material/Assessment";
// import FeedbackIcon from "@mui/icons-material/Feedback";
// import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
// import LeaderboardIcon from "@mui/icons-material/Leaderboard";
// import PointOfSaleRoundedIcon from "@mui/icons-material/PointOfSaleRounded";
// import SpeedIcon from "@mui/icons-material/Speed";
// import AnnouncementIcon from "@mui/icons-material/Announcement";
// import TroubleshootIcon from '@mui/icons-material/Troubleshoot';

function Home() {
  const outsideClickRef = useRef<HTMLDivElement | null>(null);

  const [subMenuSelection, setSubMenuSelection] = useState("");

  // Function to handle clicks outside of the modal
  const handleClickOutside = (event: MouseEvent) => {
    if (
      outsideClickRef.current &&
      !outsideClickRef.current.contains(event.target as Node)
    ) {
      setSubMenuSelection("");
    }
  };

  useEffect(() => {
    // Add event listener for mousedown
    document.addEventListener("mousedown", handleClickOutside);
    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <FadeIn transitionDuration={700}>
      <div className='home_root exec-root container'>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={1}
            ref={outsideClickRef}
            className='home-cards'
          >
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              xl={3}
              className='tile-card'
            >
              <FadeIn transitionDuration={700}>
                {subMenuSelection !== "operations" ? (
                  <div onClick={() => setSubMenuSelection("operations")}>
                    <Card variant='outlined' className='card-content main zoom'>
                      <CardContent>
                        <NetworkCheckIcon />
                        <h4>Operations</h4>
                      </CardContent>
                    </Card>
                  </div>
                ) : (
                  <FadeIn transitionDuration={700}>
                    <div className='sub-container'>
                      <NavLink
                        to='/executive'
                        className='sub-category-with-4-items'
                      >
                        <Card variant='outlined' className='card-content zoom'>
                          <CardContent>
                            <QueryStatsIcon />
                            <h4>High Level View</h4>
                          </CardContent>
                        </Card>
                      </NavLink>
                      <NavLink
                        to='/operations'
                        className='sub-category-with-4-items'
                      >
                        <Card
                          variant='outlined'
                          className='card-content sub zoom'
                        >
                          <CardContent>
                            <CandlestickChartIcon />
                            <h4>Detail View</h4>
                          </CardContent>
                        </Card>
                      </NavLink>
                      <NavLink
                        to='/agenteffectiveness'
                        className='sub-category-with-4-items'
                      >
                        <Card
                          variant='outlined'
                          className='card-content sub zoom'
                        >
                          <CardContent>
                            <SensorOccupiedIcon />
                            <h4>Agent Effectiveness</h4>
                          </CardContent>
                        </Card>
                      </NavLink>
                      <NavLink
                        to='/livediarization'
                        className='sub-category-with-4-items'
                      >
                        <Card
                          variant='outlined'
                          className='card-content sub zoom'
                        >
                          <CardContent>
                            <MicIcon />
                            <h4>Live Diarization</h4>
                          </CardContent>
                        </Card>
                      </NavLink>
                    </div>
                  </FadeIn>
                )}
              </FadeIn>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              xl={3}
              className='tile-card'
            >
              <FadeIn transitionDuration={700}>
                {subMenuSelection !== "risk-and-compliance" ? (
                  <div
                    onClick={() => setSubMenuSelection("risk-and-compliance")}
                  >
                    <Card variant='outlined' className='card-content main zoom'>
                      <CardContent>
                        <AssuredWorkloadIcon />
                        <h4>Risk and Compliance</h4>
                      </CardContent>
                    </Card>
                  </div>
                ) : (
                  <FadeIn transitionDuration={700}>
                    <div className='sub-container'>
                      <NavLink
                        to='/complaints'
                        className='sub-category-with-2-items'
                      >
                        <Card
                          variant='outlined'
                          className='card-content sub zoom'
                        >
                          <CardContent>
                            <AnnouncementIcon />
                            <h4>Complaints Monitoring</h4>
                          </CardContent>
                        </Card>
                      </NavLink>
                      <NavLink
                        to='/compliance'
                        className='sub-category-with-2-items'
                      >
                        <Card variant='outlined' className='card-content zoom'>
                          <CardContent>
                            <AssuredWorkloadIcon />
                            <h4>Disclosure Compliance Monitoring</h4>
                          </CardContent>
                        </Card>
                      </NavLink>
                    </div>
                  </FadeIn>
                )}
              </FadeIn>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              xl={3}
              className='tile-card'
            >
              <FadeIn transitionDuration={700}>
                <NavLink to='/'>
                  <Card variant='outlined' className='card-content main zoom'>
                    <CardContent>
                      <TranscribeIcon />
                      <h4>Customer Experience</h4>
                    </CardContent>
                  </Card>
                </NavLink>
              </FadeIn>
            </Grid>
            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={3}
              xl={3}
              className='tile-card'
            >
              <FadeIn transitionDuration={700}>
                <NavLink to='/'>
                  <Card variant='outlined' className='card-content main zoom'>
                    <CardContent>
                      <ShopTwoIcon />
                      <h4>Product/Digital</h4>
                    </CardContent>
                  </Card>
                </NavLink>
              </FadeIn>
            </Grid>
          </Grid>
        </Box>
      </div>
    </FadeIn>
  );
}
export default Home;
